import React from 'react';
import { getObservedAccountId, subscribeAccountBoundary, subscribeRemoteAccountChange } from '../../shared/src/lib/accountBoundary';
import { clearPrivateAccountQueries, invalidatePrivateAccountData } from '../../shared/src/lib/queryPrivacy';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@tark/shared';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

let previousAccount: string | null = null;
subscribeAccountBoundary(() => {
  const account = getObservedAccountId();
  if (previousAccount !== account) {
    previousAccount = account;
    invalidatePrivateAccountData(queryClient);
  }
});
subscribeRemoteAccountChange(() => {
  // Remove A's private data before revalidating the cookie for B.
  queryClient.setQueryData(['auth', 'user'], null);
  void clearPrivateAccountQueries(queryClient).then(() => queryClient.invalidateQueries({ queryKey: ['auth'] }));
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
